import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=22fd5611&scoped=true"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdatePage.vue?vue&type=style&index=0&id=22fd5611&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd5611",
  null
  
)

export default component.exports